// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__24GTI","right":"Footer_right__1HkVs","buttons":"Footer_buttons__2_9Hr"};